/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Honest per-booking readiness sub-state (API mirror of service derivation).

Drives the lecturer roster's explicit status labels and the student's own
waiting text instead of a bare present/absent flag. See
``app.core.services.oral_exams.cohort.derive_readiness``.
 */
export type OralExamReadiness = (typeof OralExamReadiness)[keyof typeof OralExamReadiness];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamReadiness = {
  not_joined: 'not_joined',
  in_lobby: 'in_lobby',
  awaiting_id_review: 'awaiting_id_review',
  id_rejected: 'id_rejected',
  watching_orientation: 'watching_orientation',
  ready_to_start: 'ready_to_start',
  moving_to_exam_room: 'moving_to_exam_room',
  waiting_for_examiner: 'waiting_for_examiner',
  waiting_for_student: 'waiting_for_student',
  starting_exam: 'starting_exam',
  in_exam: 'in_exam',
  not_connected: 'not_connected',
  presence_unknown: 'presence_unknown',
  completed: 'completed',
  aborted: 'aborted',
} as const;
